"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PAYMENTS_MAPPING = {
    prefix: 'payments',
    caclulateResidentAutoApplyPayment: {
        path: '/calculateResidentAutoApplyPayment',
        parameter: '/:residentId'
    },
    makeOneTimePayment: {
        path: '/makeOneTimePayment',
        parameter: '/:residentId'
    },
    getResidentPayment: {
        path: '/getResidentPayment',
        parameter: '/:paymentId'
    },
    calculateScheduledPaymentDetails: {
        path: '/calculateScheduledPaymentDetails',
        parameter: '/:residentId'
    },
    saveScheduledPayment: {
        path: '/saveScheduledPayment',
        parameter: '/:residentId'
    },
    getScheduledPayment: {
        path: '/getScheduledPayment',
        parameter: '/:scheduleId'
    },
    paymentsList: {
        path: '/paymentsList',
    },
    batchesList: {
        path: '/batchesList',
    },
    sendPaymentReceiptViaEmail: {
        path: '/sendPaymentReceiptViaEmail',
        parameter: '/:paymentId'
    },
    sendPaymentReceiptViaMail: {
        path: '/sendPaymentReceiptViaMail',
        parameter: '/:paymentId'
    },
    getResidentPaymentsByFilters: {
        path: '/getResidentPaymentsByFilters',
        parameter: '/:residentId'
    },
    getResidentPaymentTransactions: {
        path: '/getResidentPaymentTransactions',
        parameter: '/:paymentId'
    },
    getResidentScheduledPayments: {
        path: '/getResidentScheduledPayments',
        parameter: '/:residentId'
    },
    getReviewPaymentsList: {
        path: '/getReviewPaymentsList'
    },
    getScheduleItemsByFilters: {
        path: '/getScheduleItemsByFilters'
    },
    getScheduleItemTransactionsForApply: {
        path: '/getScheduleItemTransactionsForApply',
        parameter: '/:scheduleItemId'
    },
    scheduleItemProcess: {
        path: '/scheduleItemProcess',
        parameter: '/:scheduleItemId'
    },
    scheduleStop: {
        path: '/scheduleStop',
        parameter: '/:scheduleSettingId'
    },
    scheduleItemSkip: {
        path: '/scheduleItemSkip',
        parameter: '/:scheduleItemId'
    },
    scheduleItemPostpone: {
        path: '/scheduleItemPostpone',
        parameter: '/:scheduleItemId'
    },
    scheduleItemChangePaymentMethod: {
        path: '/scheduleItemChangePaymentMethod',
        parameter: '/:scheduleSettingId'
    },
    getScheduleSettingStatistics: {
        path: '/getScheduleItemsStatistics',
        parameter: '/:scheduleSettingId'
    }
};
